import IlustracaoDestaque from 'assets/img/destaque-ilustracao.png';
import { FOCO_VISIVEL } from 'utils/foco';

import { limparEFocarNaBusca } from './FiltrosDaFila';

export interface VazioDaFilaProps {
  /** Havia realizações na fase antes da busca e dos filtros. */
  haviaRealizacoes: boolean;
  onLimparFiltros: () => void;
}

/** Fila vazia (RDN-51): por causa dos filtros, com "Limpar filtros", ou porque nada chegou à apreciação. */
export default function VazioDaFila({ haviaRealizacoes, onLimparFiltros }: VazioDaFilaProps) {
  return (
    <div className="flex flex-wrap items-center gap-[26px] rounded-jj-lg border border-dashed border-surface-300 bg-brand-white p-[30px]">
      <img src={IlustracaoDestaque} alt="" className="h-auto w-[150px] shrink-0" />
      <div className="flex min-w-[240px] flex-1 flex-col gap-2.5">
        <p className="m-0 font-display text-base font-bold text-brand-blue-dark">
          {haviaRealizacoes ? 'Nenhuma realização nesta seleção' : 'Nenhuma realização chegou à sua apreciação nesta fase'}
        </p>
        <p className="m-0 max-w-[460px] text-[12.5px] leading-[1.6] text-content-soft">
          {haviaRealizacoes
            ? 'Ajuste os filtros de status, feedback ou busca para encontrar as realizações desta fase.'
            : 'Assim que as entregas forem validadas pelos líderes imediatos, elas aparecem aqui para você apreciar dentro do prazo da etapa.'}
        </p>
        {haviaRealizacoes && (
          // SPEC_DEVIATION: fundo `brand-blue-dark` no lugar do `brand-blue` do design (amarelo de 11px no azul).
          <button
            type="button"
            onClick={() => limparEFocarNaBusca(onLimparFiltros)}
            className={`mt-1 self-start rounded-jj-sm border-0 bg-brand-blue-dark px-5 py-[11px] text-[11px] font-bold uppercase tracking-[0.04em] text-brand-yellow ${FOCO_VISIVEL}`}
          >
            Limpar filtros
          </button>
        )}
      </div>
    </div>
  );
}
